import { cn } from '@/shared/utils';
import { useTranslation } from 'react-i18next';
import type { ThemeSelectItem } from '../model';

type Props = {
  theme: ThemeSelectItem | undefined;
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
};

const ThemeBaseInfo = ({
  theme,
  className,
  iconClassName,
  labelClassName,
}: Props) => {
  const { t } = useTranslation();

  if (!theme) {
    return null;
  }

  const { value, icon } = theme;

  return (
    <div className={cn('flex items-center gap-[1.6rem]', className)}>
      <img
        className={cn('w-[2.4rem] h-[2.4rem]', iconClassName)}
        src={icon}
        alt={value}
      />
      <h4 className={cn('headline4 text-primary', labelClassName)}>
        {t(`common.theme.${value}`)}
      </h4>
    </div>
  );
};

export { ThemeBaseInfo };
